import React, { useEffect, useState } from 'react';
import { fetchSchema } from '../services/api';
import { useNavigate } from 'react-router-dom';

export default function SchemaViewer() {
    const [schema, setSchema] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        loadSchema();
    }, []);

    const loadSchema = async () => {
        try {
            const res = await fetchSchema();
            setSchema(res.data);
            setError(null);
        } catch (err) {
            console.error('Failed to load schema:', err);
            setError('Failed to load schema');
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="animate-pulse p-4">Loading schema...</div>;
    if (error) return <div className="text-red-500 p-4">{error}</div>;
    if (!schema) return <div className="p-4">No schema data available</div>;

    return (
        <div className="px-4 py-5 sm:p-6">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                    Database Schema Overview
                </h3>
                <button
                    onClick={() => navigate('/schema-details')}
                    className="text-sm text-blue-600 hover:text-blue-800"
                >
                    View All →
                </button>
            </div>
            
            <div>
                <div className="bg-blue-50 rounded-lg p-4 mb-4">
                    <p className="text-2xl font-bold text-blue-900">{schema.total_tables || 0}</p>
                    <p className="text-sm text-blue-700">Total Tables</p>
                </div>
                
                {schema.tables && schema.tables.length > 0 && (
                    <>
                        <h4 className="text-sm font-medium text-gray-700 mb-2">Sample Tables:</h4>
                        <div className="space-y-2 max-h-48 overflow-y-auto">
                            {schema.tables.map((table, idx) => (
                                <div key={idx} className="bg-gray-50 rounded p-2 text-xs">
                                    <span className="font-medium">{table.table}</span>
                                    <span className="text-gray-500 ml-2">
                                        ({table.column_count} columns)
                                    </span>
                                    {table.has_foreign_keys && 
                                        <span className="ml-2 text-green-600">Has FK</span>
                                    }
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}